"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PTxInInfo = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var V1_1 = require("../../V1/index.js");
var PTxOut_1 = require("./PTxOut.js");
exports.PTxInInfo = (0, pstruct_1.pstruct)({
    PTxInInfo: {
        utxoRef: V1_1.V1.PTxOutRef.type,
        resolved: PTxOut_1.PTxOut.type
    }
});
